<template>
  <main class="container">
    <div class="row justify-content-center">
      <CategoriesList :categorias="categorias" :categoryId="categoryId" />
    </div>
    <div class="row article-container">
      <div class="col-12 col-md-3">
        <ArticlesList :categorias="categorias" :categoryId="categoryId" />
      </div>
      <div class="col-12 col-md-9">
        <SearchField />
        <ArticleComponent :categorias="categorias" />
      </div>
    </div>
    <RequestSection :telefone="telefone" :atendimento="atendimento" :chat="chat"/>
  </main>
</template>

<script>
import { configs } from "@/assets/data/data.json";
import RequestSection from "@/components/RequestSection";
import CategoriesList from "@/components/CategoriesList";
import ArticlesList from "@/components/ArticlesList";
import ArticleComponent from "@/components/ArticleComponent";
import SearchField from "@/components/SearchField";

export default {
  name: "Category",
  components: {
    RequestSection,
    CategoriesList,
    ArticlesList,
    ArticleComponent,
    SearchField
  },
  data: function() {
    return {
      categorias: "",
      categoryId: this.$route.params.categoryId,
      telefone: "",
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      let categoryId = this.$route.params.categoryId;
      this.categorias = configs[this.$parent.site].categorias;
      this.categoryId = categoryId;
      this.telefone = configs[this.$parent.site].telefone;
      this.atendimento = configs[this.$parent.site].atendimento;
      this.chat = configs[this.$parent.site].chat;
    }
  }
};
</script>

<style lang="scss">
.article-container {
  & .article-sidebar {
    border: 0;
    flex: 0 0 25%;
    height: auto;
  }
}
.article-title {
  color: black;
  font-size: 22px;
  text-transform: uppercase;
  font-weight: 700;
}
.article-content {
  margin-bottom: 50px;
  line-height: 1.6;
  & .article-body {
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    & a {
      font-weight: 700;
      &:hover {
        color: #000;
      }
    }
  }
}
</style>